import { useTranslation } from 'react-i18next';

const Demo = () => {
	const { t } = useTranslation();

	return (
		<>
			<div className="mt-20">
				<img className="mx-auto" src={require("../media/images/demo-main-banner.png")} alt="Demo Banner" />
			</div>

			<div className="flex flex-col justify-center relative max-w-screen-md z-20 mx-8 sm:mx-auto">
				<h2 className="text-6xl mt-20 mb-6 text-center">{t('demo.heading')}</h2>
				<p className="text-lg text-white mb-6 text-center">
					{t('demo.subtitle')}
				</p>
				<ul className="list-disc list-inside text-lg text-white mb-14 max-w-screen-sm	 mx-auto">
					<li>{t('demo.bullet1')}</li>
					<li>{t('demo.bullet2')}</li>
					<li>{t('demo.bullet3')}</li>
					<li>{t('demo.bullet4')}</li>
				</ul>
			</div>
		</>
	);
};

export default Demo;
